// @flow
import React, { PureComponent } from 'react';
import ButtonLink from '@liveauctioneers/caterwaul-components/lib/ButtonLink/ButtonLink';
import Cookies from 'universal-cookie';
import { faTimes } from '@fortawesome/pro-solid-svg-icons/faTimes';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormattedMessage } from 'react-intl';
import styles from './DismissableGetMobileBanner.module.scss';

const cookie = new Cookies();
const COOKIE_NAME = 'dismissableMobileBanner';

type Props = {|
    mobileBrowserOS: string,
    userLoggedIn?: boolean,
|};

type State = {|
    dismissed: boolean,
|};

export default class DismissableGetMobileBanner extends PureComponent<Props, State> {
    isBannerDismissed = () => {
        const hasBeenChecked = cookie.get(COOKIE_NAME);
        return 'dismissed' === hasBeenChecked;
    };

    setCookieChecked = () => {
        const cookieMaxAge = 86400 * 30; // 30 days
        cookie.set(COOKIE_NAME, 'dismissed', { maxAge: cookieMaxAge });
        this.setState({ dismissed: true });
    };

    render() {
        const { mobileBrowserOS, userLoggedIn } = this.props;
        if (!userLoggedIn || mobileBrowserOS === '' || this.isBannerDismissed()) {
            return null;
        }
        const navTo =
            mobileBrowserOS === 'ios'
                ? 'https://itunes.apple.com/us/app/live-auctions/id321243082'
                : 'https://play.google.com/store/apps/details?id=com.liveauctioneers.and';
        return (
            <div className={styles.mobileBannerContainer} id="mobileBanner">
                <img
                    alt="mobile"
                    className={styles.liveLogo}
                    src="https://p1.liveauctioneers.com/dist/images/mobile_icon.png"
                />
                <div className={styles.getNotificationText}>
                    <FormattedMessage id="get_notifications_from_favorite_auctioneers" />
                </div>
                <ButtonLink className={styles.getAppButton} external url={navTo}>
                    <FormattedMessage id="get_app" />
                </ButtonLink>
                <FontAwesomeIcon className={styles.closeBox} icon={faTimes} onClick={this.setCookieChecked} />
            </div>
        );
    }
}
